module.exports = __webpack_public_path__ + "static/media/check.4fd01a83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/check.svg
// module id = 2995
// module chunks = 0